// src/modules/marketplace/components/realization/realizationSummary.tsx

import { FC } from "react"
import { Box, Divider, Paper, Stack, Typography } from "@mui/material"
import { FieldView } from "@core/components"
import { Realization } from "../../interfaces"

interface IProps {
  summary: Realization.RealizationSummary | undefined
}

export const RealizationSummary: FC<IProps> = ({ summary }) => {
  if (!summary) return null

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" mb={1}>
        Сводная
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        flexWrap="wrap"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
      >
        <FieldView
          label="Реализовано (вес)"
          value={`${summary.total_weight_sold} г`}
        />
        <FieldView
          label="Выставлено (вес)"
          value={`${summary.total_weight_loaded} г`}
        />
        <FieldView
          label="Выручка (руб)"
          value={summary.total_price.toLocaleString("ru-RU")}
        />
        <FieldView
          label="Потрачено бонусов (руб)"
          value={summary.total_bonus_spent.toLocaleString("ru-RU")}
        />
        <FieldView
          label="Себес"
          value={summary.total_fine.toLocaleString("ru-RU")}
        />
        <FieldView
          label="Оплата за клад"
          value={summary.total_courier_payment.toLocaleString("ru-RU")}
        />
        <FieldView
          label="Комиссия (руб)"
          value={Number(summary.total_commission).toLocaleString("ru-RU", {
            minimumFractionDigits: 2,
          })}
        />
        <Box>
          <FieldView label="Продано позиций" value={summary.sold_count} />
          <FieldView label="Выставлено позиций" value={summary.loaded_count} />
        </Box>
      </Stack>
    </Paper>
  )
}
